import React from 'react'

export default function Feedback(props) {
  const { submissions=[] } = props
  return (
    <div>
      <h5 className="profile-header pt-4">Feedback</h5>
      <div className="row">
        <div className="col-12 p-4">
          <table className="table table-sm table-responsive">
            <thead>
              <tr>
                <th className="col-6">Date Submitted</th>
                <th className="col-6">Overall, how helpful was your experience with us?</th>
              </tr>
            </thead>
            <tbody>
              {
                submissions.map((submission, index)=>(
                  <tr key={index}>
                    <td>{ moment(submission.created_at).format("MM/DD/YYYY @ h:mmA") }</td>
                    <td>{ submission.responses[0].body }</td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
